import logo from "./logo.svg";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
// import './App.css';
import "./App.scss";
import Scanner from "./pages/Scanner";
import Progress from "./pages/Progress";
import Browse from "./pages/Browse";
import MonthlyCheck from "./pages/MonthlyCheck";

export default function App() {
  return (
    <BrowserRouter>
      <Route
        render={({ location, history }) => (
          <>
            {/* <Header/> */}
            <Switch>
              <Route path="/" component={Scanner} exact />
              <Route path="/progress" component={Progress} exact />
              <Route path="/progress/:step_no" component={Progress} exact />
              <Route path="/monthlycheck" component={MonthlyCheck} exact />
              <Route
                path="/browse_assets/:campaign_id"
                component={Browse}
                exact
              />
            </Switch>
            {/* <Footer/> */}
          </>
        )}
      />
    </BrowserRouter>
  );
}

// export default App;
